import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import "./CitizenImpactSidebar.css";

const CitizenImpactSidebar = ({
  onGenderChange,
  onAgeRangeChange,
  onStateChange,
  onDistrictChange, 
  onProjectNameChange
}) => {

  const [filters, setFilters] = useState({
    gender: [],
    ageRange: [],
    state: [],
    district: [],
    projectName: []
  });

  const [options, setOptions] = useState({
    gender: [],
    ageRange: [],
    state: [],
    district: [],
    projectName: []
  });
  const genderLabelMap = {
    M: "Male",
    F: "Female",
    O: "Others"
  };
  const [loading, setLoading] = useState(false);

  // 🔥 Utility: Build options and preserve selected values
  const buildOptions = (dataList, key, selectedList) => {
    let values = [...new Set(dataList.map((d) => d[key]).filter(Boolean))];
  
    // 🔥 If gender filter → allow only M, F, O
    if (key === "CitizenGender") {
      values = values.filter((val) => ["M", "F", "O"].includes(val));
    }
  
    const formatted = values.map((val) => {
      let label = val;
  
      if (key === "CitizenGender") {
        label = genderLabelMap[val];
      }
  
      return {
        value: val,
        label: label
      };
    });
  
    // Preserve already selected options
    const selectedFormatted = (selectedList || []).map((item) => ({
      value: item.value,
      label: item.label
    }));
  
    const combined = [
      ...formatted,
      ...selectedFormatted.filter(
        (sel) => !formatted.some((opt) => opt.value === sel.value)
      )
    ];
  
    return combined;
  };

  // 🔥 Fetch filter options dynamically
  const fetchFilterOptions = async (appliedFilters = {}) => {
    try {
      setLoading(true);
  
      const res = await axios.post(
        "https://api-sales-insights.haqdarshak.com/api/citizen-impact/filter-options",
        appliedFilters
      );
  
      const data = res.data || {};
  
      setOptions({
        gender: (data.gender || []).map(val => ({
          value: val,
          label: genderLabelMap[val] || val
        })),
        ageRange: (data.ageRange || []).map(val => ({
          value: val,
          label: val
        })),
        state: (data.state || []).map(val => ({
          value: val,
          label: val
        })),
        district: (data.district || []).map(val => ({
          value: val,
          label: val
        })),
        projectName: (data.projectName || []).map(val => ({
          value: val,
          label: val
        }))
      });
  
    } catch (err) {
      console.error("Filter fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    fetchFilterOptions();
  }, []);

  // 🔥 Handle multi-select change
  const handleChange = (key, selectedOptions) => {

    const updatedFilters = {
      ...filters,
      [key]: selectedOptions || []
    };
  
    setFilters(updatedFilters);
  
    const apiFilters = {
      gender: updatedFilters.gender.map(o => o.value),
      ageRange: updatedFilters.ageRange.map(o => o.value),
      state: updatedFilters.state.map(o => o.value),
      district: updatedFilters.district.map(o => o.value),
      projectName: updatedFilters.projectName.map(o => o.value)
    };
  
    // ✅ REFRESH OPTIONS DYNAMICALLY
    fetchFilterOptions(apiFilters);
  
    if (key === "gender") onGenderChange(apiFilters.gender);
    if (key === "ageRange") onAgeRangeChange(apiFilters.ageRange);
    if (key === "state") onStateChange(apiFilters.state);
    if (key === "district") onDistrictChange(apiFilters.district);
    if (key === "projectName") onProjectNameChange(apiFilters.projectName);
  };

  // 🔥 Clear all filters
  const clearAllFilters = () => {

    const emptyFilters = {
      gender: [],
      ageRange: [],
      state: [],
      district: [],
      projectName: []
    };

    setFilters(emptyFilters);

    fetchFilterOptions({});

    onGenderChange([]);
    onAgeRangeChange([]);
    onStateChange([]);
    onDistrictChange([]);   // 🔥 Add this prop
    onProjectNameChange([]);
  };

  return (
    <div className="citizen-impact-sidebar">
      <h2>Heat Map Filters</h2>

      {/* Project */}
      <div className="filter-group">
        <label>Project</label>
        <Select
          options={options.projectName}
          value={filters.projectName}
          onChange={(val) => handleChange("projectName", val)}
          isMulti
          isClearable
          isLoading={loading}
          closeMenuOnSelect={false}
        />
      </div>

      {/* State */}
      <div className="filter-group">
        <label>State</label>
        <Select
          options={options.state}
          value={filters.state}
          onChange={(val) => handleChange("state", val)}
          isMulti
          isClearable
          isLoading={loading}
          closeMenuOnSelect={false}
        />
      </div>
{/* District */}
<div className="filter-group">
  <label>District</label>
  <Select
    options={options.district}
    value={filters.district}
    onChange={(val) => handleChange("district", val)}
    isMulti
    isClearable
    isLoading={loading}
    closeMenuOnSelect={false}
  />
</div>
      {/* Gender */}
      <div className="filter-group">
        <label>Gender</label>
        <Select
          options={options.gender}
          value={filters.gender}
          onChange={(val) => handleChange("gender", val)}
          isMulti
          isClearable
          isLoading={loading}
          closeMenuOnSelect={false}
        />
      </div>

      {/* Age Range */}
      <div className="filter-group">
        <label>Age Range</label>
        <Select
          options={options.ageRange}
          value={filters.ageRange}
          onChange={(val) => handleChange("ageRange", val)}
          isMulti
          isClearable
          isLoading={loading}
          closeMenuOnSelect={false}
        />
      </div>

      <button className="clear-btn" onClick={clearAllFilters}>
        Clear All Filters
      </button>
    </div>
  );
};

export default CitizenImpactSidebar;